import React, { useEffect, useState } from 'react';
import apiClient from '../api';
import {
    Box, Typography, Table, TableHead, TableBody, TableRow, TableCell,
    Chip, Button, CircularProgress, Alert,
} from '@mui/material';
import moment from 'jalali-moment';
import { formatToman } from '../labels';
import { glass } from '../theme';

const STATUS_LABELS = {
    pending_release: 'در دوره‌ی نگهداری',
    released: 'واریز شده',
    on_hold: 'متوقف‌شده',
};
const STATUS_COLORS = { pending_release: 'warning', released: 'success', on_hold: 'error' };

function AdminPayouts() {
    const [payouts, setPayouts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busyId, setBusyId] = useState(null);
    const [error, setError] = useState('');

    const load = () => {
        setLoading(true);
        apiClient.get('/api/admin-panel/payouts/')
            .then((res) => setPayouts(res.data))
            .catch(() => setError('خطا در دریافت لیست تسویه‌ها.'))
            .finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const handleRelease = async (id) => {
        setBusyId(id);
        try {
            await apiClient.post(`/api/admin-panel/payouts/${id}/release/`);
            load();
        } catch {
            setError('خطا در ثبت واریز.');
        } finally {
            setBusyId(null);
        }
    };

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>;
    }

    return (
        <Box>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>تسویه با همیاران</Typography>
            <Typography color="text.secondary" sx={{ mb: 2 }}>
                هر ردیف یعنی خانواده پرداخت کرده و کار تکمیل شده — وجه نزد پلتفرم است تا واریز دستی به همیار انجام شود.
            </Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            {payouts.length === 0 ? (
                <Box sx={{ ...glass.card, p: 4, textAlign: 'center' }}>
                    <Typography color="text.secondary">هنوز هیچ تسویه‌ای ثبت نشده — این پس از پرداخت و اتمام یک درخواست ایجاد می‌شود.</Typography>
                </Box>
            ) : (
                <Box sx={{ ...glass.card, overflow: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>همیار</TableCell>
                                <TableCell>درخواست</TableCell>
                                <TableCell>مبلغ کل</TableCell>
                                <TableCell>کارمزد</TableCell>
                                <TableCell>مبلغ قابل واریز</TableCell>
                                <TableCell>زودترین زمان واریز</TableCell>
                                <TableCell>وضعیت</TableCell>
                                <TableCell>عملیات</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payouts.map((p) => {
                                const eligible = new Date(p.eligible_release_at) <= new Date();
                                return (
                                    <TableRow key={p.id} hover>
                                        <TableCell>{p.provider_name}</TableCell>
                                        <TableCell>#{p.request}</TableCell>
                                        <TableCell>{formatToman(p.gross_amount)}</TableCell>
                                        <TableCell>{formatToman(p.commission_amount)} ({p.commission_percent}٪)</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }}>{formatToman(p.net_amount)}</TableCell>
                                        <TableCell>{moment(p.eligible_release_at).locale('fa').format('D MMMM YYYY')}</TableCell>
                                        <TableCell>
                                            <Chip size="small" label={STATUS_LABELS[p.status] || p.status} color={STATUS_COLORS[p.status] || 'default'} />
                                        </TableCell>
                                        <TableCell>
                                            {p.status === 'pending_release' && (
                                                <Button
                                                    size="small" variant={eligible ? 'contained' : 'outlined'}
                                                    disabled={busyId === p.id}
                                                    onClick={() => handleRelease(p.id)}
                                                >
                                                    {eligible ? 'ثبت واریز' : 'واریز زودهنگام'}
                                                </Button>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Box>
            )}
        </Box>
    );
}

export default AdminPayouts;
